/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupFormWarningsData
 */
export interface AgencyGroupFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyGroupFormWarningsData
     */
    label?: ValidationMessage;
}

export function AgencyGroupFormWarningsDataFromJSON(json: any): AgencyGroupFormWarningsData {
    return AgencyGroupFormWarningsDataFromJSONTyped(json, false);
}

export function AgencyGroupFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
    };
}

export function AgencyGroupFormWarningsDataToJSON(value?: AgencyGroupFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
    };
}


